import { RegistrationFeature } from './registration-feature.enum';

export type RegistrationFeatures = Partial<
  Record<RegistrationFeature, boolean>
>;
